export const DEFAULT_DATE_TIME = 'yyyy-MM-dd HH:mm';
export const DEFAULT_DATE = 'yyyy-MM-dd';